import {
  abergavennychronicleConfig,
  altonheraldConfig,
  bordonheraldConfig,
  breconradnorConfig,
  cambrianNewsConfig,
  chepstowbeacon,
  CreditonCourier,
  DartmouthChronicle,
  DawlishGazette,
  farnhamheraldConfig,
  haslemereheraldConfig,
  IvybridgeSouthBrentGazette,
  KingsbridgeSalcombeGazette,
  liphookheraldConfig,
  MidDevonAdvertiser,
  monmouthshirebeaconConfig,
  narberthAndWhitlandTodayConfig,
  OkehamptonTimes,
  pembrokeTodayConfig,
  petersfieldpostConfig,
  rossgazetteConfig,
  SouthHamsGazette,
  TamarValleyTimes,
  tavistockToday,
  TeignmouthPost,
  tenbyTodayConfig,
  theforesterConfig,
  theforestreviewConfig,
  TotnesTimes,
  IOM,
  TheCornishTimes,
  BudeStrattonPost,
  Holsworth,
  MidsomerNorton,
  WellingtonWeeklyNews,
  WestSomersetFreePress,
  Voice,
  WokingAndDaily,
} from "./index"; // Assuming index.ts is in the same directory

const config: { [unit: string]: any } = {
  ["petersfieldpost.co.uk"]: petersfieldpostConfig,
  ["farnhamherald.com"]: farnhamheraldConfig,
  ["altonherald.com"]: altonheraldConfig,
  ["bordonherald.com"]: bordonheraldConfig,
  ["haslemereherald.com"]: haslemereheraldConfig,
  ["liphookherald.com"]: liphookheraldConfig,
  ["abergavennychronicle.com"]: abergavennychronicleConfig,
  ["monmouthshirebeacon.co.uk"]: monmouthshirebeaconConfig,
  ["chepstowbeacon.co.uk"]: chepstowbeacon,
  ["brecon-radnor.co.uk"]: breconradnorConfig,
  ["cambrian-news.co.uk"]: cambrianNewsConfig,
  ["tenby-today.co.uk"]: tenbyTodayConfig,
  ["narberth-and-whitland-today.co.uk"]: narberthAndWhitlandTodayConfig,
  ["pembroke-today.co.uk"]: pembrokeTodayConfig,
  ["theforester.co.uk"]: theforesterConfig,
  ["rossgazette.com"]: rossgazetteConfig,
  ["theforestreview.co.uk"]: theforestreviewConfig,
  ["tavistock-today.co.uk"]: tavistockToday,
  ["middevonadvertiser.co.uk"]: MidDevonAdvertiser,
  ["dawlish-today.co.uk"]: DawlishGazette,
  ["teignmouth-today.co.uk"]: TeignmouthPost,
  ["dartmouth-today.co.uk"]: DartmouthChronicle,
  ["ivybridge-today.co.uk"]: IvybridgeSouthBrentGazette,
  ["kingsbridge-today.co.uk"]: KingsbridgeSalcombeGazette,
  ["southhams-today.co.uk"]: SouthHamsGazette,
  ["totnes-today.co.uk"]: TotnesTimes,
  ["tamarvalleytimes.co.uk"]: TamarValleyTimes,
  ["okehampton-today.co.uk"]: OkehamptonTimes,
  ["creditoncourier.co.uk"]: CreditonCourier,
  ["iomtoday.co.im"]: IOM,
  ["wokingnewsandmail.co.uk"]: WokingAndDaily,
  ["thepost.uk.com"]: TheCornishTimes,
  ["bude-today.co.uk"]: BudeStrattonPost,
  ["holsworthy-today.co.uk"]: Holsworth,
  ["cornish-times.co.uk"]: TheCornishTimes,
  ["mnrjournal.co.uk"]: MidsomerNorton,
  ["wellington-today.co.uk"]: WellingtonWeeklyNews,
  ["wsfp.co.uk"]: WestSomersetFreePress,
  ["voicenewspapers.co.uk"]: Voice,
};

export const publicationsConfig = config; 